<p-sidebar
  [modal]="true"
  [visible]="true"
  [styleClass]="'w-11'"
  (onHide)="closeReport()">
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-3">
      <app-header
        icon="fas fa-clipboard-list"
        text="Vergleichsbericht für"></app-header>

      <app-type-dropdown
        mode="all"
        [selection]="dataLayerType || null"
        [displayNewLayerTypeOption]="true"
        (selectionChange)="changeDataLayerType($event)"></app-type-dropdown>

      @if (dataLayerType) {
        <app-layer-dropdown
          [selectedTypeId]="dataLayerType._id"
          [displayNewYearOption]="false"
          [selection]="dataLayer"
          (ngModelChange)="changeDataLayer($event)"
          [(ngModel)]="dataLayer"></app-layer-dropdown>
      }

      @if (dataLayer) {
        <div class="ml-auto">
          <app-feature-dropdown
            [dataLayerId]="dataLayer._id"
            [selection]="districtKey || ''"
            (selectionChange)="
              changeDistrictKey($event)
            "></app-feature-dropdown>
        </div>
      }

      @if (districtKey) {
        <p-button
          [rounded]="true"
          label="Bericht exportieren"
          icon="fas fa-file-excel"
          (click)="export()"></p-button>
      }
    </div>
  </ng-template>

  @if (!districtKey) {
    <app-alert
      header="Treffen Sie eine Auswahl, um einen Vergleich zu erstellen."
      [canToggle]="false">
      <ol>
        <li>Wählen Sie einen Raum oder eine Standort-Ebene.</li>
        <li>
          Wählen Sie das Jahr in welchem der Vergleich erstellt werden soll.
        </li>
        <li>
          Wählen Sie einen Teilraum oder einen Standort um den Vergleich zu
          generieren.
        </li>
      </ol>
    </app-alert>
  }
  @if (tree && tree.length && dataLayer && districtKey) {
    <p-treeTable
      #tt
      styleClass="p-treetable-sm text-md"
      filterMode="lenient"
      [globalFilterFields]="['label']"
      [paginator]="tree.length > 15"
      [rows]="15"
      [scrollable]="true"
      class="w-full"
      [value]="tree">
      <ng-template pTemplate="caption">
        <div class="flex justify-content-end align-items-center w-full">
          <div class="p-input-icon-left w-full">
            <i class="fas fa-search"></i>
            <input
              class="w-full"
              type="text"
              pInputText
              placeholder="durchsuchen ..."
              (input)="
                tt.filterGlobal(getTarget($event.target).value, 'contains')
              " />
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 35rem">Name</th>
          <th>Min</th>
          <th>Max</th>
          <th>AVG</th>
          <th>Wert</th>
          <th style="width: 20rem">Vergleich</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttRow]="rowNode">
          <td style="width: 35rem">
            <div class="flex align-items-center gap-2">
              <p-treeTableToggler [rowNode]="rowNode"> </p-treeTableToggler>
              {{ rowData?.label }}
              @if (rowData?.type === 'indicator') {
                <app-unit mode="short" [unitKey]="rowData.unit"></app-unit>
              }
            </div>
          </td>
          @if (rowData && rowData.type === 'indicator') {
            <td>
              {{
                getValueFormatted(
                  getMinValue(dataLayer._id, rowData._id),
                  rowData._id
                )
              }}
            </td>
            <td>
              {{
                getValueFormatted(
                  getMaxValue(dataLayer._id, rowData._id),
                  rowData._id
                )
              }}
            </td>
            <td>
              {{ getValueFormatted(getAvgValue(rowData._id), rowData._id) }}
            </td>
            <td>{{ getValueFormatted(getValue(rowData._id), rowData._id) }}</td>
            <td style="width: 20rem">
              <app-value-comparison-visual
                [indicatorId]="rowData._id"
                [min]="getMinValue(dataLayer._id, rowData._id)"
                [max]="getMaxValue(dataLayer._id, rowData._id)"
                [value]="getValue(rowData._id)"
                [comp]="getAvgValue(rowData._id)" />
            </td>
          } @else {
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          }
        </tr>
      </ng-template>
    </p-treeTable>
  }
</p-sidebar>
